import Vue from 'vue';
// import router from '../router';
import transferDom from '@/components/CloudIView/directives/transfer-dom';
// import mainBg from '@/assets/image/main-bg.png';

const directives = {
  'canvas-bg': {
    inserted(el, binding, vNode) {
      if (binding.value === 'image') {
        window.$(el).addClass('pg-image');
      }
    },
    update(el, binding, vNode) {
      if (binding.value === 'image') {
        window.$(el)[0].classList.forEach(item => {
          if (item.indexOf('pg-image-') !== -1) {
            window.$(el).removeClass(item);
          }
        });
        window.$(el).addClass(`pg-image-${localStorage.getItem('themeColor').slice(1)}`);
        window.$(el).removeClass('pg-canvas');
        window.$(el).removeClass(`theme-color-${localStorage.getItem('themeColor').slice(1)}`);
      }
    },
  },
  'transfer-dom': transferDom,
  'no-e': {
    bind(el) {
      el.addEventListener('keydown', e => {
        if (e.key === 'e' || e.key === 'E') {
          e.preventDefault();
        }
      });

      el.addEventListener('input', e => {
        if (/[eE]/.test(e.target.value)) {
          e.target.value = e.target.value.replace(/[eE]/g, '');
          e.target.dispatchEvent(new Event('input'));
        }
        if (e.target.value === '') e.target.value = 1;
        // 匹配数字和小数点，且小数部分最多两位
        let match = e.target.value.match(/^\d*\.?\d{0,2}/);
        e.target.value = match ? match[0] : 1;
        e.target.dispatchEvent(new Event('input'));
      });

      el.addEventListener('change', e => {
        console.log('e.target.value', e.target.value);
        if (e.target.value === '') e.target.value = 1;
        // 匹配数字和小数点，且小数部分最多两位
        let match = e.target._value.match(/^\d*\.?\d{0,2}/);
        e.target.value = match ? match[0] : 1;
        e.target.dispatchEvent(new Event('change'));
      });
    },
  },
};

Object.keys(directives).forEach(directive => {
  Vue.directive(directive, { ...directives[directive] });
});
